var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03734 0 0 4.03734 0 9C0 13.9627 4.03734 18 9 18C13.9627 18 18 13.9627 18 9C18 4.03734 13.9627 0 9 0ZM9 16.875C4.65778 16.875 1.125 13.3422 1.125 9C1.125 4.65778 4.6575 1.125 9 1.125C13.3422 1.125 16.875 4.65778 16.875 9C16.875 13.3422 13.3422 16.875 9 16.875Z",
    fill: "#002447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0651 11.6092V6.96094H7.22021V8.352H8.13737V11.6092H7.22021V13.0002H10.9634V11.6092H10.0651Z",
    fill: "#002447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87166 4.48318C9.66775 4.2759 9.41857 4.17212 9.12325 4.17212C8.83188 4.17212 8.58354 4.2759 8.37766 4.48318C8.17207 4.69046 8.06885 4.93937 8.06885 5.22962C8.06885 5.51593 8.17263 5.76259 8.38047 5.96987C8.58832 6.17715 8.83638 6.28093 9.12325 6.28093C9.41407 6.28093 9.66269 6.17856 9.86857 5.97296C10.0744 5.76793 10.1774 5.52015 10.1774 5.22962C10.1774 4.93909 10.0756 4.69046 9.87166 4.48318Z",
    fill: "#002447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.597f7cd8e82fa5151b0fe5a530ba988f.svg";
export { ForwardRef as ReactComponent };